/* --- Script for 100% VH -- */
function setSlideshowHeight() {
    const announcementBar = document.querySelector('.announcement-bar');
    const header = document.querySelector('header');
    const headerSecondary = document.querySelector('.nav-secondary-menu');
    // Determine height of elements
    let announcementBarHeight = announcementBar?.offsetHeight || 0 ;
    let headerHeight = header?.offsetHeight || 0 ;
    let headerSecondaryHeight = headerSecondary?.offsetHeight || 0 ;
    let totalHeight = announcementBarHeight + headerHeight + headerSecondaryHeight;
    // Get Slideshow element
    const slideshow = document.getElementById('slideshow');
    if (!slideshow) return;
    // Set the height of the slideshow
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const finalHeight = Math.max(0, viewportHeight - totalHeight);
    slideshow.style.minHeight = `${finalHeight}px`
    slideshow.style.height = `${finalHeight}px`;
    slideshow.style.maxHeight = `${finalHeight}px`;
}
window.addEventListener('DOMContentLoaded', setSlideshowHeight);
window.addEventListener('resize', setSlideshowHeight);